import React, {
    useEffect,
    useState
}
from "react";

import { useHistory }
from "react-router-dom";

import DashboardInsightDrawer
from "./components/dashboard/DashboardInsightDrawer";

import Header
from "../../components/Header";

import LeftMenu
from "../../components/LeftMenu";

import useInsights
from "./hooks/useInsights";

import InsightDashboardHeroChart
from "./components/dashboard/InsightDashboardHeroChart";

import InsightDashboardRiskMatrix
from "./components/dashboard/InsightDashboardRiskMatrix";

import InsightDashboardComplianceChart
from "./components/dashboard/InsightDashboardComplianceChart";

import InsightDashboardUrgencyChart
from "./components/dashboard/InsightDashboardUrgencyChart";

import InsightDashboardPriorityBubbles
from "./components/dashboard/InsightDashboardPriorityBubbles";

import {OMNISCAN_BLUE} from "../../constants/colors";


export default function InsightDashboard()
{
	
	const history =
	    useHistory();

	const restoredExplorer =
	    history.location.state
	    &&
	    history.location.state.insightExplorer
	        ?
	        history.location.state.insightExplorer
	        :
	        null;

			const [
			    showDashboardInsightDrawer,
			    setShowDashboardInsightDrawer
			] =
			    useState(
			        restoredExplorer
			            ?
			            restoredExplorer.display
			            :
			            false
			    );



		const [
		    filteredDashboardInsights,
		    setFilteredDashboardInsights
		] =
		    useState([]);


			const [
			    selectedInsightCategory,
			    setSelectedInsightCategory
			] =
			    useState(
			        restoredExplorer
			            ?
			            restoredExplorer.title
			            :
			            null
			    );

				const {
				    dashboard,
				    dashboardLoading,
				    loadDashboard,

				    insightList,
				    insightListLoading,

				    loadInsightListForCategory,
				    loadInsightListForRisk
				} = useInsights();
	
		//--------------------------------------------------------
		// Restore explorer data after returning from insight
		//--------------------------------------------------------

		useEffect(
		    () =>
		    {
		        if(
		            restoredExplorer
		            &&
		            restoredExplorer.title
		        )
		        {
		            loadInsightListForCategory(
		                restoredExplorer.title
		            );
		        }
		    },
		    []
		);


    //--------------------------------------------------------
    // Load dashboard
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            loadDashboard();
        },
        []
    );


    //--------------------------------------------------------
    // Debug dashboard response
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            if(dashboard)
            {
                console.log(
                    "INSIGHT DASHBOARD:",
                    dashboard
                );
            }
        },
        [dashboard]
    );
	
	//--------------------------------------------------------
	// Hero chart click
	//--------------------------------------------------------

	const handleHeroChartClick =
	    (item, type) =>
	    {
	        console.log(
	            "HERO CHART CLICK:",
	            type,
	            item
	        );


	        if(!item)
	        {
	            return;
	        }


	        //----------------------------------------------------
	        // Category
	        //----------------------------------------------------

	        if(type === "CATEGORY")
	        {
	            const category =
	                item.name;


	            console.log(
	                "CATEGORY CLICK:",
	                category
	            );


	            setSelectedInsightCategory(
	                category
	            );


	            loadInsightListForCategory(
	                category
	            );


				

				setShowDashboardInsightDrawer(
				    true
				);


	            return;
	        }


	        //----------------------------------------------------
	        // Subcategory
	        //----------------------------------------------------

	        if(type === "SUBCATEGORY")
	        {
	            console.log(
	                "SUBCATEGORY CLICK:",
	                item.name
	            );
	        }
	    };

    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div style={pageStyle}>

            <Header
                showSurveySelector={false}
                transitionHide={true}
            />

            <LeftMenu />

            <div style={overlayStyle} />


            <main style={dashboardContainerStyle}>

                {
                    dashboardLoading
                    ?
                        <div style={loadingStyle}>
                            Loading dashboard...
                        </div>
                    :
                    dashboard
                    ?
                        <div style={dashboardBodyStyle}>


                            {/*--------------------------------*/}
                            {/* LEFT DASHBOARD                  */}
                            {/*--------------------------------*/}

                            <div style={leftDashboardStyle}>


                                {/*----------------------------*/}
                                {/* KPI STRIP                   */}
                                {/*----------------------------*/}

                                <div style={kpiContainerStyle}>

                                    <DashboardKpi
                                        label="Insights"
                                        value={
                                            dashboard.totalInsights
                                        }
                                        description="AI generated findings"
                                    />

                                    <DashboardKpi
                                        label="Observations"
                                        value={
                                            dashboard.totalObservations
                                        }
                                        description="Visual observations"
                                    />

                                    <DashboardKpi
                                        label="Potential Assets"
                                        value={
                                            dashboard.totalPotentialAssets
                                        }
                                        description="Detected assets"
                                    />

                                    <DashboardKpi
                                        label="Locations"
                                        value={
                                            dashboard.totalLocations
                                        }
                                        description="Camera Points"
                                    />

                                </div>


                                {/*----------------------------*/}
                                {/* HERO CHART                  */}
                                {/*----------------------------*/}

                                <div style={heroPanelStyle}>

                                    <div style={heroChartContainerStyle}>

                                        <InsightDashboardHeroChart
                                            data={
                                                dashboard.categories
                                                ||
                                                []
                                            }

											clickFunction={
											    handleHeroChartClick
											}
                                        />

                                    </div>

                                </div>

                            </div>


                            {/*--------------------------------*/}
                            {/* RIGHT HAND CHARTS               */}
                            {/*--------------------------------*/}

                            <div style={rightChartsStyle}>


                                {/*----------------------------*/}
                                {/* RISK MATRIX                 */}
                                {/*----------------------------*/}

								<div
								    style={{
								        ...smallChartPanelStyle,
								        ...topRightChartPanelStyle
								    }}
								>

                                    <div style={smallChartHeaderStyle}>

                                        <div style={smallChartTitleStyle}>
                                            Severity
                                        </div>

                                        <div style={smallChartSubtitleStyle}>
                                            Risk profile
                                        </div>

                                    </div>


                                    <div style={chartPlaceholderStyle}>

									<InsightDashboardRiskMatrix
									    data={
									        dashboard.riskMatrix
									        ||
									        []
									    }

									    clickFunction={(
									        probability,
									        consequence
									    ) =>
									    {
									        console.log(
									            "RISK MATRIX CLICK:",
									            probability,
									            consequence
									        );


									        setSelectedInsightCategory(
									            "Risk: "
									            +
									            probability
									            +
									            " / "
									            +
									            consequence
									        );


									        loadInsightListForRisk(
									            probability,
									            consequence
									        );


									        setShowDashboardInsightDrawer(
									            true
									        );
									    }}
									/>

                                    </div>

                                </div>


								{/*----------------------------*/}
								{/* COMPLIANCE                  */}
								{/*----------------------------*/}

								<div
								    style={{
								        ...smallChartPanelStyle,
								        ...middleRightChartPanelStyle
								    }}
								>

								    <div style={smallChartHeaderStyle}>

								        <div style={smallChartTitleStyle}>
								            Compliance
								        </div>

								        <div style={smallChartSubtitleStyle}>
								            Portfolio compliance position
								        </div>

								    </div>


								    <div style={chartPlaceholderStyle}>

								        <InsightDashboardComplianceChart
								            data={
								                dashboard.compliance
								                ||
								                []
								            }

								            clickFunction={(item) =>
								            {
								                console.log(
								                    "COMPLIANCE CLICK:",
								                    item
								                );
								            }}
								        />

								    </div>

								</div>


								{/*----------------------------*/}
								{/* OPERATIONAL DISRUPTION      */}
								{/*----------------------------*/}

								<div
								    style={{
								        ...smallChartPanelStyle,
								        ...bottomRightChartPanelStyle
								    }}
								>

								    <div style={smallChartHeaderStyle}>

								        <div style={smallChartTitleStyle}>
								            Operational Disruption
								        </div>

								        <div style={smallChartSubtitleStyle}>
								            Expected impact on operations
								        </div>

								    </div>


								    <div style={chartPlaceholderStyle}>

								        <InsightDashboardPriorityBubbles
								            data={
								                dashboard.operationalDisruption
								                ||
								                []
								            }

								            clickFunction={(item) =>
								            {
								                console.log(
								                    "OPERATIONAL DISRUPTION CLICK:",
								                    item
								                );
								            }}
								        />

								    </div>

								</div>

                            </div>

                        </div>
                    :
                        <div style={loadingStyle}>
                            Dashboard unavailable
                        </div>
                }

            </main>
			<DashboardInsightDrawer
			    display={
			        showDashboardInsightDrawer
			    }

			    title={
			        selectedInsightCategory
			    }

			    insights={
			        insightList
			        ||
			        []
			    }

			    loading={
			        insightListLoading
			    }

			    closeFunction={() =>
			    {
			        setShowDashboardInsightDrawer(
			            false
			        );
			    }}

			    insightClickFunction={(insight) =>
			    {
			        history.push(
			            "/insight/"
			            +
			            insight.id
			        );
			    }}
			/>
        </div>

    );
}


//--------------------------------------------------------
// KPI
//--------------------------------------------------------

function DashboardKpi({
    label,
    value,
    description
})
{

    return (

        <div style={kpiStyle}>

            <div style={kpiLabelStyle}>
                {label}
            </div>

            <div style={kpiValueStyle}>
                {
                    value !== null
                    &&
                    value !== undefined
                        ?
                        value.toLocaleString()
                        :
                        "—"
                }
            </div>

            <div style={kpiDescriptionStyle}>
                {description}
            </div>
			
        </div>

    );
}


//--------------------------------------------------------
// Page
//--------------------------------------------------------

const pageStyle =
{
    position: "fixed",

    inset: 0,

    display: "flex",
    flexDirection: "column",

    paddingLeft: "60px",

    overflow: "hidden"
};


const dashboardContainerStyle =
{
    position: "relative",

    zIndex: 2,

    flex: 1,
    minHeight: 0,

    display: "flex",
    flexDirection: "column",

    padding: "18px 22px 22px 22px",

    overflow: "hidden"
};


//--------------------------------------------------------
// Overlay
//--------------------------------------------------------

const overlayStyle =
{
    position: "fixed",

    top: 0,
    left: 0,

    width: "100%",
    height: "100%",

    background:
        "rgba(255,255,255,0.85)",

    pointerEvents: "none",

    opacity: 0,

    animation:
        "fadeOverlay 4s ease forwards"
};


//--------------------------------------------------------
// Main dashboard
//--------------------------------------------------------

const dashboardBodyStyle =
{
    flex: 1,
    minHeight: 0,

    display: "grid",

    gridTemplateColumns:
        "minmax(0, 2.25fr) minmax(320px, 0.75fr)",

    gap: "14px"
};


//--------------------------------------------------------
// Left dashboard
//--------------------------------------------------------

const leftDashboardStyle =
{
    minWidth: 0,
    minHeight: 0,

    display: "flex",
    flexDirection: "column",

    gap: "10px",

    overflow: "hidden"
};


//--------------------------------------------------------
// KPI strip
//--------------------------------------------------------

const kpiContainerStyle =
{
    flexShrink: 0,

    display: "grid",

    gridTemplateColumns:
        "repeat(4, minmax(0, 1fr))",

    gap: "10px"
};


const kpiStyle =
{
    position: "relative",
    minWidth: 0,

    padding: "9px 14px",

    overflow: "hidden",

    background:
        "linear-gradient(to bottom, #30353c 0%, #1c2025 48%, #0f1114 100%)",

    border:
        "1px solid rgba(255,255,255,0.10)",

    borderRadius:
        "0px",

    boxShadow:
        "0 5px 14px rgba(20,35,50,0.14), " +
        "inset 0 1px 0 rgba(255,255,255,0.06)"
};


const kpiLabelStyle =
{
    marginBottom: "2px",

    color: "#9aa8bb",

    fontSize: "8px",
    fontWeight: "800",

    letterSpacing: "1px",

    textTransform: "uppercase"
};


const kpiValueStyle =
{
    color: OMNISCAN_BLUE,

    fontSize: "23px",
    lineHeight: "1.05",

    fontWeight: "800",

    textShadow:
        "0 2px 10px rgba(71,125,245,0.18)"
};


const kpiDescriptionStyle =
{
    marginTop: "3px",

    color: "#c0c8d3",

    fontSize: "9px",
    fontWeight: "600"
};


//--------------------------------------------------------
// Hero panel
//--------------------------------------------------------

const heroPanelStyle =
{
    flex: 1,

    minWidth: 0,
    minHeight: 0,

    display: "flex",
    flexDirection: "column",

    overflow: "hidden"
};


const heroChartContainerStyle =
{
    flex: 1,

    minWidth: 0,
    minHeight: 0,

    padding: "0 10px 0 10px"
};


//--------------------------------------------------------
// Right hand charts
//--------------------------------------------------------

const rightChartsStyle =
{
    minWidth: 0,
    minHeight: 0,

    display: "grid",

    gridTemplateRows:
        "1.75fr 0.9fr 0.9fr",

    gap:
        "5px"
};


const smallChartPanelStyle =
{
    minHeight: 0,

    display: "flex",
    flexDirection: "column",

    overflow: "hidden",

    padding:
        "14px 16px",

    background:
        "linear-gradient(145deg, #ffffff 0%, #f3f5f6 100%)",

    border:
        "1px solid rgba(205,212,218,0.72)",

    borderRadius:
        "0px",

    boxShadow:
        "0 5px 14px rgba(20,35,50,0.11)"
};


const smallChartHeaderStyle =
{
    flexShrink: 0
};


const smallChartTitleStyle =
{
    color: "#29313b",

    fontSize: "12px",
    fontWeight: "800"
};


const smallChartSubtitleStyle =
{
    marginTop: "2px",

    color: "#929dab",

    fontSize: "9.5px",
    fontWeight: "600"
};


const chartPlaceholderStyle =
{
    flex: 1,

    minWidth: 0,
    minHeight: 0,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    overflow: "hidden",

    color: "#a1aab6",

    fontSize: "10px",
    fontWeight: "700"
};


//--------------------------------------------------------
// Loading
//--------------------------------------------------------

const loadingStyle =
{
    flex: 1,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    color: "#768294",

    fontSize: "13px",
    fontWeight: "700"
};


const topRightChartPanelStyle =
{
    borderTopLeftRadius:
        "6px",

    borderTopRightRadius:
        "6px"
};


const middleRightChartPanelStyle =
{
    borderRadius:
        "0px"
};


const bottomRightChartPanelStyle =
{
    borderBottomLeftRadius:
        "6px",

    borderBottomRightRadius:
        "6px"
};